export default function calculateRemainderFromSum(
  values: (number | null)[] = [],
  remainderFrom: number,
): number {
  if (typeof remainderFrom !== 'number') {
    throw new Error('remainderFrom must be a number');
  }

  const sum = values.reduce((total: number, value) => total + (value || 0), 0);

  return remainderFrom - sum;
}
